import React from 'react'
import TextField from '../../../baseApp/shared/components/fields/textField/TextField';
import { I18n } from 'react-redux-i18n';
import SwitchField from '../../../baseApp/shared/components/fields/switchField/SwitchField';
import FormDivider from './../../../baseApp/shared/components/others/Divider';
import TimeField from './../../../baseApp/shared/components/fields/dateTime/TimeField';
import SelectField from "../../../baseApp/shared/components/fields/selectField/SelectField";

const MeetingRoomSubForm = ({
    providerList,
    operationTimeStart,
    email,
    provider,
    status,
    operationTimeEnd,
    minimumSchedulingPeriod,
    capacity,
    area,
    hasQuickBook,
    allowCancelQuickBook,
    checkInOpen,
    calendarDepth,
    maxMeetingTime,
    minMeetingTime,
    quickBookPeriod,
    tolerancePeriod,
    logoUrl,
    viewMode,
    editMode,
    createMode,
    handleFieldChange
}) => {
    //If the user does not have access to providers, disable provider field
    let providerFieldRefactored = {
        value: provider.value,
        data: [...providerList],
        disabled: false
    };

    if(!createMode && providerFieldRefactored.data.length === 0) {
        providerFieldRefactored.data = [{
            value: providerFieldRefactored.value,
            label: '- - -'
        }];
        providerFieldRefactored.disabled = true;
    }

    return <div id="meeting-room-sub-form">
        <div className="field-row">
            <div className="row">
                <SelectField
                    value={providerFieldRefactored.value}
                    label={I18n.t("meetingRooms.form.subForm.provider")}
                    handleFieldChange={value => handleFieldChange("provider", value)}
                    options={providerFieldRefactored.data}
                    disabled={viewMode || providerFieldRefactored.disabled}
                    error={provider.error}
                    width={4}
                />
                <TextField
                    value={minimumSchedulingPeriod.value}
                    error={minimumSchedulingPeriod.error}
                    label={I18n.t("meetingRooms.form.subForm.minimumSchedulingPeriod")}
                    handleFieldChange={value => handleFieldChange("minimumSchedulingPeriod", value)}
                    themeName="form"
                    disabled={viewMode}
                    width={4}
                />
            </div>
            <div className="row">
                <TimeField
                    value={operationTimeStart.value}
                    error={operationTimeStart.error}
                    label={I18n.t("meetingRooms.form.subForm.openingTime")}
                    handleFieldChange={value => handleFieldChange("operationTimeStart", value)}
                    themeName="form"
                    disabled={viewMode}
                    width={2}
                />
                <TimeField
                    value={operationTimeEnd.value}
                    error={operationTimeEnd.error}
                    label={I18n.t("meetingRooms.form.subForm.closingTime")}
                    handleFieldChange={value => handleFieldChange("operationTimeEnd", value)}
                    themeName="form"
                    disabled={viewMode}
                    width={2}
                />
                <TextField
                    value={capacity.value}
                    error={capacity.error}
                    label={I18n.t("meetingRooms.form.subForm.maxCapacity")}
                    handleFieldChange={value => handleFieldChange("capacity", value)}
                    themeName="form"
                    disabled={viewMode}
                    width={2}
                />
                <TextField
                    value={area.value}
                    error={area.error}
                    label={I18n.t("meetingRooms.form.subForm.area")}
                    handleFieldChange={value => handleFieldChange("area", value)}
                    themeName="form"
                    disabled={viewMode}
                    width={2}
                />
            </div>
            <div className="row mt-4">
                <SwitchField
                    handleFieldChange={value => handleFieldChange("hasQuickBook", value)}
                    checked={hasQuickBook.value}
                    label={I18n.t("meetingRooms.form.subForm.allowsQuickBook")}
                    disabled={viewMode}
                    width={2}
                />
                {buildQuickBookCancelField(hasQuickBook.value, allowCancelQuickBook, handleFieldChange, viewMode)}
            </div>
        </div>
        <FormDivider display={hasQuickBook.value}/>
        {buildQuickBookFields(hasQuickBook.value, maxMeetingTime, minMeetingTime, quickBookPeriod, handleFieldChange, viewMode)}
        <FormDivider />
        <div className="field-row">
            <div className="row">
                <TextField
                    value={checkInOpen.value}
                    error={checkInOpen.error}
                    endAdornment={I18n.t("fields.units.minutes")}
                    label={I18n.t("meetingRooms.form.subForm.checkInTime")}
                    handleFieldChange={value => handleFieldChange("checkInOpen", value)}
                    themeName="form"
                    disabled={viewMode}
                    width={4}
                />
                <TextField
                    value={calendarDepth.value}
                    error={calendarDepth.error}
                    label={I18n.t("meetingRooms.form.subForm.calendarDepth")}
                    formHelperText={I18n.t("meetingRooms.form.helpers.weeks")}
                    handleFieldChange={value => handleFieldChange("calendarDepth", value)}
                    themeName="form"
                    disabled={viewMode}
                    width={4}
                />
            </div>
            <div className="row">
                <TextField
                    value={tolerancePeriod.value}
                    error={tolerancePeriod.error}
                    endAdornment={I18n.t("fields.units.minutes")}
                    formHelperText={I18n.t("meetingRooms.form.helpers.tolerance")}
                    label={I18n.t("meetingRooms.form.subForm.tolerance")}
                    handleFieldChange={value => handleFieldChange("tolerancePeriod", value)}
                    themeName="form"
                    disabled={viewMode}
                    width={4}
                />
                <SelectField
                    value={status.value==="DISCONNECTED"?"ENABLED":status.value}
                    label={I18n.t("meetingRooms.form.subForm.status")}
                    handleFieldChange={value => handleFieldChange("status", value)}
                    options={[
                        {value: "ENABLED", label:  I18n.t("meetingRooms.form.status.enabled")},
                        {value: "DISABLED", label: I18n.t("meetingRooms.form.status.disabled")},
                    ]}
                    disabled={viewMode}
                    error={status.error}
                    width={4}
                />
            </div>
            <div className="row">
                <TextField
                    value={logoUrl.value}
                    error={logoUrl.error}
                    label={I18n.t("meetingRooms.form.subForm.logoUrl")}
                    handleFieldChange={value => handleFieldChange("logoUrl", value)}
                    themeName="form"
                    disabled={viewMode}
                    width={4}
                />
                <TextField
                    value={email.value}
                    error={email.error}
                    label={I18n.t("meetingRooms.form.subForm.email")}
                    handleFieldChange={value => handleFieldChange("email", value)}
                    themeName="form"
                    disabled={viewMode}
                    width={4}
                />
            </div>
        </div>
    </div>
};

function buildQuickBookCancelField(hasQuickBook, allowCancelQuickBook, handleFieldChange, viewMode) {
    if (hasQuickBook) {
        return <SwitchField
            handleFieldChange={value => handleFieldChange("allowCancelQuickBook", value)}
            checked={allowCancelQuickBook.value}
            label={I18n.t("meetingRooms.form.subForm.allowsQuickBookCancel")}
            disabled={viewMode}
            width={2}
        />;
    }
}

function buildQuickBookFields(hasQuickBook, maxMeetingTime, minMeetingTime, quickBookPeriod, handleFieldChange, viewMode) {
        return hasQuickBook && <React.Fragment>
            <div className="field-row">
                <div className="row">
                    <TextField
                        value={maxMeetingTime.value}
                        error={maxMeetingTime.error}
                        endAdornment={I18n.t("fields.units.hours")}
                        label={I18n.t("meetingRooms.form.subForm.maxMeetingTime")}
                        handleFieldChange={value => handleFieldChange("maxMeetingTime", value)}
                        themeName="form"
                        disabled={viewMode}
                        width={4}
                    />
                    <TextField
                        value={minMeetingTime.value}
                        error={minMeetingTime.error}
                        endAdornment={I18n.t("fields.units.minutes")}
                        label={I18n.t("meetingRooms.form.subForm.minMeetingTime")}
                        handleFieldChange={value => handleFieldChange("minMeetingTime", value)}
                        themeName="form"
                        disabled={viewMode}
                        width={4}
                    />
                </div>
                <div className="row">
                        <TextField
                            value={quickBookPeriod.value}
                            error={quickBookPeriod.error}
                            endAdornment={I18n.t("fields.units.hours")}
                            label={I18n.t("meetingRooms.form.subForm.quickBookPeriod")}
                            handleFieldChange={value => handleFieldChange("quickBookPeriod", value)}
                            themeName="form"
                            disabled={viewMode}
                            width={4}
                        />
                </div>
            </div>
        </React.Fragment>;
}

export default MeetingRoomSubForm;
